(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("BrowserRouter", ["React"], factory);
	else if(typeof exports === 'object')
		exports["BrowserRouter"] = factory(require("react"));
	else
		root["BrowserRouter"] = factory(root["React"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return 